import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Heart } from "lucide-react";

interface ActiveMatchesCardProps {
  count: number;
  onViewAll: () => void;
}

export function ActiveMatchesCard({ count, onViewAll }: ActiveMatchesCardProps) {
  return (
    <Card>
      <CardHeader>
        <div className="flex items-center justify-between">
          <CardTitle>Active Matches</CardTitle>
          <Badge variant="default">{count}</Badge>
        </div>
        <CardDescription>
          Matches where both parties accepted
        </CardDescription>
      </CardHeader>
      <CardContent>
        {count === 0 ? (
          <div className="flex flex-col items-center justify-center py-8 text-center">
            <Heart className="h-12 w-12 text-muted-foreground mb-3" />
            <p className="text-sm text-muted-foreground">No active matches yet</p>
            <p className="text-xs text-muted-foreground mt-1">
              Keep your profile active and complete!
            </p>
          </div>
        ) : (
          <div className="space-y-4">
            <div className="text-center py-4">
              <p className="text-3xl font-bold text-primary">{count}</p>
              <p className="text-sm text-muted-foreground mt-1">
                {count === 1 ? 'Active Match' : 'Active Matches'}
              </p>
            </div>
            <Button onClick={onViewAll} className="w-full" variant="outline">
              View All Matches
            </Button>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
